//video events
import $ from 'jquery';
import NProgress from 'nprogress';

import config from './globals/config';
import setActiveColor from './../modules/set-active-color';
import videoLoad from './video-load';


export default function (player, location) {
  let trailerDrawerUI = location === 'main' ? $('.trailer-drawer-ui') : $('#trailerModal .trailer-drawer-ui');
  let currentTimeUI = trailerDrawerUI.find('.time .current'),
    durationTimeUI = trailerDrawerUI.find('.time .duration'),
    meter = trailerDrawerUI.find('.meter');

  this.seek = function (value) {
    let time = player.duration() * (value / 100);
    player.currentTime(time);
  };

  this.setCurrentTime = function () {
    let currentTime = Math.floor(player.currentTime());
    let durationTime = player.duration();

    let minutes = '0' + Math.floor(currentTime / 60);
    let seconds = '0' + (currentTime - minutes * 60);

    if (config.currentPage === 'homepage') {
      config.activeTrailer.find('.time .current').text(minutes.substr(-2) + ':' + seconds.substr(-2));
      config.activeTrailer.find('.meter').css({ 'width': (player.currentTime() / durationTime) * 100 + '%' });
    } else {
      currentTimeUI.text(minutes.substr(-2) + ':' + seconds.substr(-2));
      meter.css({ 'width': (player.currentTime() / durationTime) * 100 + '%' });
    }
  };

  this.setDurationTime = function () {
    let durationTime = Math.floor(player.duration());
    let minutes = '0' + Math.floor(durationTime / 60);
    let seconds = '0' + (durationTime - minutes * 60);

    if (config.currentPage === 'homepage') {
      config.activeTrailer.find('.time .duration').text(minutes.substr(-2) + ':' + seconds.substr(-2));
    } else {
      durationTimeUI.text(minutes.substr(-2) + ':' + seconds.substr(-2));
    }
  };

  this.stopVideoPlayer = function () {
    if (player) {
      player.pause();
    }
  };

  this.unmutePlayer = function () {
    player.volume(1);
  };

  this.fullscreen = function () {
    player.requestFullscreen();
  };

  this.setNextActive = function () {
    if (config.currentPage === 'homepage') {
      let nextActive = config.activeTrailer.next().length > 0 ?
        config.activeTrailer.next() :
        $($('#trailersSlices li')[0]);

      NProgress.start();

      let slices = $('#trailersSlices');

      let active = slices.find('.active');
      active.removeClass('active').removeClass('header-larger').find('a');

      //var nextActive = active.next();
      nextActive.addClass('active').find('a');

      setTimeout(function () {
        nextActive.addClass('header-larger');
      }, 150);

      if (config.isMute) {
        nextActive.find('.mute').addClass('hide');
        nextActive.find('.unmute').removeClass('hide');
      } else {
        nextActive.find('.mute').removeClass('hide');
        nextActive.find('.unmute').addClass('hide');
      }

      setActiveColor($('body'), slices);

      setTimeout(function () {
        // dont if already initialized?
        $('input[type="range"]', nextActive).rangeslider('update', true);
        videoLoad($('.vjs-loading-spinner'), $('.active').data('video-id'), config.myPlayer);

      }, 1000);

    } else if (config.currentPage === 'single') {
      $('#rightTrailer').trigger('click');
    }
  };
}
